import { render, staticRenderFns } from "./WorkplaceConfig.vue?vue&type=template&id=3e2758fe&scoped=true"
import script from "./WorkplaceConfig.vue?vue&type=script&lang=js"
export * from "./WorkplaceConfig.vue?vue&type=script&lang=js"
import style0 from "./WorkplaceConfig.vue?vue&type=style&index=0&id=3e2758fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2758fe",
  null
  
)

export default component.exports